import { cx } from "@/utils/cx";
import {
  TIME_RANGE_OPTIONS,
  type TimeRange,
} from "../../schemas/tenantDashboard";

/**
 * UC-005 TimeRangeSelector — radiogroup pro výběr 6M / 12M / All (Phase 23).
 *
 * Pattern: aria-pressed buttons (jako sync-history filter chips) — color-not-only
 * (text + visual state). Touch target ≥ 48px per REQ-UI-008/014/020.
 */

const LABELS: Record<TimeRange, string> = {
  "6M": "6 měsíců",
  "12M": "12 měsíců",
  ALL: "Vše",
};

export interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
  ariaLabel?: string;
}

export function TimeRangeSelector({
  value,
  onChange,
  ariaLabel = "Časové období",
}: TimeRangeSelectorProps) {
  return (
    <div
      className="flex flex-wrap gap-2"
      role="group"
      aria-label={ariaLabel}
      data-testid="time-range-selector"
    >
      {TIME_RANGE_OPTIONS.map((opt) => {
        const isActive = value === opt;
        return (
          <button
            key={opt}
            type="button"
            className={cx(
              "min-h-touch cursor-pointer rounded-full px-4 py-[0.4rem] font-medium ring-1 ring-inset outline-focus-ring focus-visible:outline-2 focus-visible:outline-offset-2",
              isActive
                ? "bg-brand-solid text-white ring-brand"
                : "bg-transparent text-primary ring-secondary",
            )}
            aria-pressed={isActive}
            onClick={() => onChange(opt)}
            data-testid={`time-range-${opt}`}
          >
            {LABELS[opt]}
          </button>
        );
      })}
    </div>
  );
}
